import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rodape-login',
  templateUrl: './rodape-login.component.html',
  styleUrls: ['./rodape-login.component.scss']
})
export class RodapeLoginComponent implements OnInit {

  anoAtual = 0;
  constructor() { }

  ngOnInit() {
    this.anoAtual = new Date().getFullYear();
  }

}
